import { StatusStepData, StepData } from './types';

export const isStepStatusStep = (step: StepData): step is StatusStepData =>
    step.layout === 'status';
